// Positions a floating card (ui/SidePopover, the font list, the emoji picker) just right of the left panel,
// level with the control that opened it, and kept inside the viewport.
const GAP = 12;

export default {
  methods: {
    sidePopoverPosition(trigger, { width = 300, height = 360 } = {}) {
      if (!trigger || !trigger.getBoundingClientRect) {
        return { top: GAP, left: GAP };
      }
      const sidebar = trigger.closest ? trigger.closest('.main-panel-wrapper') : null;
      const anchor  = (sidebar || trigger).getBoundingClientRect();
      const rect    = trigger.getBoundingClientRect();
      const left    = Math.min(anchor.right + GAP, window.innerWidth - width - GAP);
      const top     = Math.min(rect.top, window.innerHeight - height - GAP);
      return { top: Math.max(GAP, top), left: Math.max(GAP, left) };
    },
    // After the card is in the DOM, pull it up or left so its real size stays on screen.
    fitSidePopover(popover, position) {
      const component = Array.isArray(popover)
        ? popover.find(item => item && item.$el && item.$el.getBoundingClientRect)
        : popover;
      const el = component && component.$el;
      if (!el || !el.getBoundingClientRect || !position) {
        return position;
      }
      const rect = el.getBoundingClientRect();
      if (!rect.height) {
        return position;
      }
      let { top, left } = position;
      if (top + rect.height > window.innerHeight - GAP) {
        top = Math.max(GAP, window.innerHeight - rect.height - GAP);
      }
      if (left + rect.width > window.innerWidth - GAP) {
        left = Math.max(GAP, window.innerWidth - rect.width - GAP);
      }
      return { top, left };
    },
  },
};
